import React from 'react';

import { PrimaryButton, TextButton } from '@components/Button/variants';
import IconBillLong from '@components/Images/Rebranding/IconBillLong';
import IconEnvelopeWithMoney from '@components/Images/Rebranding/IconEnvelopeWithMoney';
import IconGearWithAvatar from '@components/Images/Rebranding/IconGearWithAvatar';

import Benefit, { BenefitProps } from './Benefit';

const BENEFITS: BenefitProps[] = [
  {
    Icon: IconEnvelopeWithMoney,
    description: 'Pricing structures specifically created for educational institutions',
  },
  {
    Icon: IconGearWithAvatar,
    description: 'Custom delivery mechanisms to suit administrators',
  },
  {
    Icon: IconBillLong,
    description: 'Simplified billing and account management that grows with you',
  },
];

const Education = () => {
  return (
    <article
      id="Education"
      className="mt-64 flex flex-col items-center bg-grayscale-beige px-16 py-48 sm:px-48 md:px-[160px] xl:px-[376px] xl:py-64 dark:bg-[var(--light-grayscale-charcoal)]"
    >
      <div className="flex max-w-[688px] flex-col items-center">
        <h2 className="my-0 text-center font-suisse-works text-headline-xs sm:text-headline-md">
          Higher Education
        </h2>
        <p className="mb-0 mt-8 text-center font-suisse-neue text-body-md text-primary-black sm:mt-16 sm:text-subheadline-md">
          Set your students and faculty up for success with impactful and award-winning journalism
          that the most influential leaders in tech read daily.
        </p>
        <div className="max-w-[475px]">
          {BENEFITS.map((benefit, index) => (
            <Benefit key={index} Icon={benefit.Icon} description={benefit.description} />
          ))}
        </div>
        <PrimaryButton as="link" href="#IntroAndForm" className="anchor-link mt-48">
          Learn more
        </PrimaryButton>
        <TextButton as="link" href="#IntroAndForm" className="anchor-link mt-16">
          Go to top
        </TextButton>
      </div>
    </article>
  );
};

export default Education;
